define(["require", "exports", "tslib", "@material-ui/core/styles", "mobx-react", "react", "../../store/UIStore", "./index"], function (require, exports, tslib_1, styles_1, mobx_react_1, React, UIStore_1, index_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.HeaderButton = void 0;
    React = tslib_1.__importStar(React);
    const theme = (0, styles_1.createTheme)({
        overrides: {
            MuiButton: {
                containedPrimary: {
                    color: "white",
                    background: "linear-gradient(to left, #31BBE6, #3ac)"
                },
                containedSecondary: {
                    color: "white",
                },
                contained: {
                    boxShadow: UIStore_1.boxShadow
                }
            }
        },
        palette: {
            primary: {
                main: "#31BBE6",
            },
            secondary: {
                main: "#31BBE6"
            }
        }
    });
    exports.HeaderButton = (0, mobx_react_1.observer)((props) => {
        const styles = props.backgroundColor && props.hoverColor
            ? Object.assign(Object.assign({}, theme), { overrides: Object.assign(Object.assign({}, theme.overrides), { MuiButton: Object.assign(Object.assign({}, theme.overrides.MuiButton), { containedPrimary: {
                            color: "white",
                            background: "inherit",
                            backgroundColor: props.backgroundColor,
                            '&:hover': {
                                backgroundColor: props.hoverColor
                            }
                        } }) }) }) : theme;
        return React.createElement(index_1.CtaButton, { id: props.id || props.label, label: props.label, onClick: props.onClick, variant: "contained", color: props.color || "primary", disabled: props.disabled, theme: styles });
    });
});
